import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const HrMenu = () => {
	const staff = useSelector(state => state.user.profile);
	const isHrManager = staff.role.slug === 'hr-manager';

	return (
		<>
			{isHrManager && (
				<li className="sub-header">
					<span>STAFF MANAGEMENT</span>
				</li>
			)}
			{['hr-manager', 'it-admin'].includes(staff.role.slug) && (
				<li>
					<Link to="/hr/overview">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Overview</span>
					</Link>
				</li>
			)}
			<li>
				<Link to="/hr/staffs">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Staff List</span>
				</Link>
			</li>
			<li>
				<Link to="/hr/departments">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Departments</span>
				</Link>
			</li>
			<li>
				<Link to="/hr/units">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Units</span>
				</Link>
			</li>

			{isHrManager && (
				<li className="sub-header">
					<span>WORKFORCE</span>
				</li>
			)}
			{['hr-manager', 'it-admin', ''].includes(staff.role.slug) && (
				<li>
					<Link to="/hr/appraisal">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Appraisal</span>
					</Link>
				</li>
			)}
			<li>
				<Link to="/hr/leave-mgt">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Leave Mgt</span>
				</Link>
			</li>
			<li>
				<Link to="/hr/duty-roster">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Schedule</span>
				</Link>
			</li>
			<li>
				<Link to="/hr/attendance">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Attendance</span>
				</Link>
			</li>
			<li>
				<Link to="/hr/excuse-duty">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-13" />
					</div>
					<span>Excuse duty</span>
				</Link>
			</li>

			{staff.role.slug !== 'hr-officer' && (
				<>
					{isHrManager && (
						<li className="sub-header">
							<span>PAYROLL & REPORTS</span>
						</li>
					)}
					<li>
						<Link to="/accounting/payroll">
							<div className="icon-w">
								<div className="os-icon os-icon-layers" />
							</div>
							<span>Payroll</span>
						</Link>
					</li>
					<li>
						<Link to="/accounting/config">
							<div className="icon-w">
								<div className="os-icon os-icon-layers" />
							</div>
							<span>Payroll Settings</span>
						</Link>
					</li>
				</>
			)}
			<li>
				<Link to="/report/human-resources">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>HR Reports</span>
				</Link>
			</li>
		</>
	);
};

export default HrMenu;
